

const dev = window.location.host.includes("localhost");

const API_DOMAIN = dev ? "https://devappapi.gotrycatch.com" : "https://appapi.gotrycatch.com"; // https://jalgae.com

const PRIVATE_API = `${API_DOMAIN}/gtc`;
const PUBLIC_API = `${API_DOMAIN}/gtc`;

export const API_URL: any = {
    PRIVATE_API: PRIVATE_API,
    PUBLIC_API: PUBLIC_API
}

export const API_CONSTANTS: any = {
    PRIVATE_API: "PRIVATE_API",
    PUBLIC_API: "PUBLIC_API"
}

export const apiRequest = async (params : any) => {
    const { method, api, fn, data, content } = params;
    if (!api) { return; }
    try {
        if (method === "POST") {
            const responseData = await fetch(`${API_URL[api]}?fn=${fn}`, {
                method: 'POST',
                body: content == "json" ? JSON.stringify(data) : data,
                credentials: 'include'
            })
            return await responseData.json();
        }
        else if (method === "GET") {
            const queryParams = Object.keys(data || {}).map((key) => `${key}=${data[key] || ''}`).join("&")
            const url = `${API_URL[api]}?fn=${fn}&${queryParams}`;
            const responseData = await fetch(url, {
                credentials: 'include'
            })
            return await responseData.json();
        } else {
            return null;
        }
    } catch (error) {
        console.log("apiRequest", api, error)
        return null;
    }
}


const ApiRequest = () => {
    return {
        apiRequest,
        API_CONSTANTS,
        API_URL
    }
} 

export default ApiRequest;